export default __webpack_public_path__ + "static/media/danji_cg_02_big.02cd1887.jpg";